module.exports = __webpack_public_path__ + "static/media/image_girl.ba0cebe3.png";